import { RegionsEnum } from '@pages/sales-network/RegionsEnum';
import { RegionModel } from '@pages/sales-network/regions-clinics/RegionModel';



export const regionsLinks: RegionModel[] = [
	{
		region: RegionsEnum.jihocesky,
		name: 'Jihočeský kraj',
		clinics: [
			{
				name: 'Veterinární klinika BUDvet',
				link: 'https://www.budvet.cz',
			},
			{
				name: 'Veterina MVDr. Veronika Křížová',
				link: 'https://www.veterinakrizova.cz',
			},
			{
				name: 'Veterina U Beránků',
				link: 'https://uberanku.cz',
			},
		],
	},
	{
		region: RegionsEnum.jihomoravsky,
		name: 'Jihomoravský kraj',
		clinics: [
			{
				name: 'Veterina Bystrc s.r.o.',
				link: 'http://veterinabystrc.cz',
			},
			{
				name: 'Veterinární ordinace MVDr. Viera Zekuciová',
				link: 'https://www.zekuvet.cz',
			},
			{
				name: 'Veterinární klinika MVDr. Marek Šupica',
				link: 'https://www.veterinaivancice.cz',
			},
			{
				name: 'Veterinární klinika Vyvet Vyškov',
				link: 'https://www.veterinar-vyskov.cz',
			},
		],
	},
	{
		region: RegionsEnum.karlovarsky,
		name: 'Karlovarský kraj',
		clinics: [
			{
				name: 'Vetmedik s.r.o.',
				link: 'https://vetmedik.cz',
			},
		],
	},
	{
		region: RegionsEnum.kralovehradecky,
		name: 'Královéhradecký kraj',
		clinics: [],
	},
	{
		region: RegionsEnum.liberecky,
		name: 'Liberecký kraj',
		clinics: [
			{
				name: 'Veterinární ordinace DUOVET',
				link: 'https://www.duovet.cz',
			},
			{
				name: 'Veterinární praxe FRYVET v.o.s',
				link: 'http://fryvet.cz',
			},
		],
	},
	{
		region: RegionsEnum.moravskoslezsky,
		name: 'Moravskoslezský kraj',
		clinics: [
			{
				name: 'Vetmanie',
				link: 'https://www.vetmanie.cz',
			},
			{
				name: 'Veterinární ošetřovna Nový Jičín',
				link: 'https://www.veterinanovyjicin.cz',
			},
			{
				name: 'MVDr. Michaela Hlubková',
				link: 'http://www.veterinarni-klinika-krmelin.cz',
			},
		],
	},
	{
		region: RegionsEnum.olomoucky,
		name: 'Olomoucký kraj',
		clinics: [
			{
				name: 'Veterinární ordinace Vetmedical Litovel',
				link: 'https://www.veterinalitovel.cz',
			},
		],
	},
	{
		region: RegionsEnum.pardubicky,
		name: 'Pardubický kraj',
		clinics: [
			{
				name: 'Veterinární ordinace Rozárka',
				link: 'https://veterinarozarka.cz',
			},
		],
	},
	{
		region: RegionsEnum.plzensky,
		name: 'Plzeňský kraj',
		clinics: [
			{
				name: 'Veterinární ordinace MVDr. František Zahrádka',
				link: 'https://mvdrzahradka.estranky.cz/clanky/kontakt.html',
			},
			{
				name: 'Veterinární klinika ZODIACUS 97 s.r.o.',
				link: 'https://veterina-plzen.cz',
			},
			{
				name: 'Veterina Rokycany',
				link: 'https://veterinarokycany.cz',
			},
			{
				name: 'VetOrdinace MVDr. Linda Hynčíková Birnerová',
				link: 'https://www.ordinace.vet',
			},
			{
				name: 'Veterinární ordinace Tachov',
				link: 'http://www.veterina-tachov.cz',
			},
			{
				name: 'Veterinární ordinace Medicus Veterinarius',
				link: 'http://www.medvet.cz',
			},
			{
				name: 'Veterinární ordinace VINIVET',
				link: 'https://vinivet.cz',
			},
			{
				name: 'Veterinární ordinace MVDr. Radek Šerý',
				link: 'https://www.firmy.cz/detail/2643824-mvdr-radek-sery-rokycany-nove-mesto.html',
			},
			{
				name: 'Veterinární ordinace Kralovice',
				link: 'https://vet-viktora.sluzby.cz',
			},
			{
				name: 'Veterinární ordinace MVDr. Václav Kasl a MVDr. Ingrid Kaslová',
				link: 'https://www.firmy.cz/detail/2118873-veterinarni-ordinace-mvdr-vaclav-kasl-a-mvdr-ingrid-kaslova-prestice.html',
			},
			{
				name: 'Veterinární ordinace v Horní Bříze',
				link: 'http://www.hobrvet.cz',
			},
			{
				name: 'Veterinární ordinace Kdyně',
				link: 'https://www.veterinakdyne.cz',
			},
			{
				name: 'Veterina Slovany',
				link: 'https://www.veterina-plzenslovany.cz',
			},
			{
				name: 'MVDr. Ludvík Mikoška, Sušice',
				link: 'https://www.firmy.cz/detail/2116859-mvdr-ludvik-mikoska-susice-ii.html',
			},
			{
				name: 'MVDr. Magdalena Kůttová, Blovice',
				link: 'https://g.co/kgs/bQfyVUk',
			},
		],
	},
	{
		region: RegionsEnum.praha,
		name: 'Hlavní město Praha',
		clinics: [
			{
				name: 'Veterinární klinika VetPoint',
				link: 'http://vetpoint.cz',
			},
			{
				name: 'MVDr. Martina Načeradská - Veterinární ordinace',
				link: 'https://www.naceradska.cz',
			},
			{
				name: 'AAVET - Veterinární nemocnice a ambulance',
				link: 'https://www.aavet.cz',
			},
			{
				name: 'Veterinární klinika Donovalská',
				link: 'https://www.veterinadonovalska.cz',
			},
			{
				name: 'Veterinární klinika Na Hůrce',
				link: 'https://www.vets4pets.cz',
			},
			{
				name: 'Veterinární klinika Dejvice',
				link: 'https://www.vaseveterina.cz',
			},
			{
				name: 'Veterinární klinika Zbraslav',
				link: 'https://veterinazbraslav.cz',
			},
		],
	},
	{
		region: RegionsEnum.stredocesky,
		name: 'Středočeský kraj',
		clinics: [
			{
				name: 'Veterinární klinika Na Weilovně',
				link: 'https://www.weilovna.cz',
			},
			{
				name: 'Veterinární klinika ZVÍŘECÍ DOKTOR',
				link: 'https://zvireci-doktor.cz',
			},
			{
				name: 'Veterinární klinika Mada',
				link: 'https://www.veterinamada.cz',
			},
			{
				name: 'Veterinární klinika Roztoky',
				link: 'https://www.vaseveterina.cz',
			},
		],
	},
	{
		region: RegionsEnum.ustecky,
		name: 'Ústecký kraj',
		clinics: [
			{
				name: 'Veterinární klinika Chomutov s.r.o.',
				link: 'http://www.veterinachomutov.cz',
			},
			{
				name: 'Veterinární klinika Mi-Vet',
				link: 'https://www.mi-vet.cz',
			},
		],
	},
	{
		region: RegionsEnum.vysocina,
		name: 'Kraj Vysočina',
		clinics: [],
	},
	{
		region: RegionsEnum.zlinsky,
		name: 'Zlínský kraj',
		clinics: [],
	},
]